export default "__VITE_ASSET__DcltVg_u__"